import React, {useState, useCallback, useEffect, useRef} from 'react';
import {useDropzone} from 'react-dropzone';
import Cookies from 'js-cookie';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {DragNDrop} from '../../assets';
import Swal from 'sweetalert2';
import {Box} from '@mui/material';
import {Loader} from '../Loader';
import {Language} from '../../context/LanguageContext';
import {useUser} from '../../hooks';

export default function ATDDropzone({onChange}) {
  const {language, newObj} = Language();
  const [searchParams] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const [steps, setSteps] = useState(0);
  const {
    uploadAtdPhSawit,
    uploadAtdPhGetah,
    uploadAtdNpkSawit,
    uploadAtdNpkGetah,
  } = useUser();
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const [payload, setPayload] = useState({
    type: 'ph',
    jenisTanaman: '',
  });
  const [file, setFile] = useState();
  const [uploadStatus, setUploadStatus] = useState('Uploading...');
  const tokens_session = Cookies.get('token');
  const navigate = useNavigate();
  const lang = useRef(language);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const urlProgressSawit = `${apiUrl}/atd/ph/progress-sawit?token=Bearer ${tokens_session}`;
  const urlProgressGetah = `${apiUrl}/atd/ph/progress-getah?token=Bearer ${tokens_session}`;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    onChange(steps);
  }, [steps]);

  const uploadFile = async (file) => {
    setSteps(1);
    setFile(file);
  };

  useEffect(() => {
    lang.current = language;
  }, [language]);

  const handleSubmit = useCallback(
    async (file) => {
      let guidValue;
      setSteps(2);
      setProgress(0);
      let response;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('lang', lang.current == 1 ? 'en' : 'my');
      let eventSource = new EventSource(`${apiUrl}/atd/progress`);

      eventSource.addEventListener('GUI_ID', async (event) => {
        console.log(`Guid from server: ${guidValue}`);
        guidValue = event.data.replace(/"/g, '');
        formData.append('guid', guidValue);
        eventSource.addEventListener(guidValue, (event) => {
          const result = JSON.parse(event.data);
          if (progress !== result.progress) {
            setProgress(result.progress);
          }
          if (uploadStatus !== result?.status) {
            setUploadStatus(result?.status);
          }
          if (result?.status === 'Done!') {
            eventSource.close();
          } else if (result.status === 'Error!') {
            setProgress(0);
            onChange(0);
            eventSource.close();
          }
        });

        if (payload.type === 'ph')
          if (payload.jenisTanaman === 'sawit')
            response = await uploadAtdPhSawit(tokens_session, formData);
          else response = await uploadAtdPhGetah(tokens_session, formData);
        else if (payload.type === 'npk')
          if (payload.jenisTanaman === 'sawit')
            response = await uploadAtdNpkSawit(tokens_session, formData);
          else response = await uploadAtdNpkGetah(tokens_session, formData);
        if (response?.status === 200) {
          setSteps(3);
          eventSource.close();
        } else {
          setSteps(0);
          setProgress(0);
          onChange(0);
          eventSource.close();
        }
      });
      eventSource.onerror = (event) => {};
    },

    [payload, tokens_session, lang.current]
  );

  const onDrop = useCallback(
    (acceptedFiles) => {
      // Handle the dropped files here
      acceptedFiles.forEach((file) => {
        handleSubmit(file);
      });
    },
    [payload, tokens_session, lang.current]
  );
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    rejectedFiles,
    isDragReject,
  } = useDropzone({
    onDrop,
    multiple: false,
    minSize: 0,
    accept: {},
  });
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
      {...(steps === 1 && getRootProps())}
    >
      {steps === 1 && (
        <input
          {...getInputProps()}
          style={{
            display: 'block',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
            cursor: 'pointer',
          }}
        />
      )}
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {steps === 0 && (
          <div
            style={{
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: '20px',
                width: '100%',
                padding: '0px',
              }}
            >
              <p
                style={{
                  width: '100%',
                  color: '#fff',
                  fontSize: '14px',
                  padding: '30px 30px 10px',
                  fontWeight: 'bold',
                }}
              >
                {newObj.ATDWord[language]}
              </p>

              <p
                style={{
                  width: '100%',
                  color: '#fff',
                  fontSize: '14px',
                  opacity: '0.75',
                  padding: '0px 30px 80px',
                }}
              >
                {newObj.ATDDropzone[language]}
              </p>

              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  background: '#1C3E69',
                  height: '100%',
                  padding: '20px 0px',
                  position: 'relative',
                  borderTop: '1.5px solid white',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: '-38px',
                    left: '30px',
                  }}
                >
                  <button
                    style={{
                      background:
                        payload.type === 'ph' ? '#1C3E69' : 'transparent',
                      borderStyle: 'solid solid none solid',
                      borderColor: 'white',
                      borderWidth: payload.type === 'ph' ? '1.5px' : '0',
                      borderRadius: '10px 10px 0 0',
                      padding: '10px 30px',
                      color: 'white',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      setPayload((prev) => ({
                        ...prev,
                        type: 'ph',
                        jenisTanaman: '',
                      }))
                    }
                  >
                    PH
                  </button>
                  <button
                    style={{
                      background:
                        payload.type === 'npk' ? '#1C3E69' : 'transparent',
                      borderStyle: 'solid solid none solid',
                      borderColor: 'white',
                      borderWidth: payload.type === 'npk' ? '1.5px' : '0',
                      borderRadius: '10px 10px 0 0',
                      padding: '10px 30px',
                      color: 'white',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      setPayload((prev) => ({
                        ...prev,
                        type: 'npk',
                        jenisTanaman: '',
                      }))
                    }
                  >
                    NPK
                  </button>
                </div>
                <button
                  style={{
                    width: '75%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    background: '#5076ee',
                    margin: '0px auto 0px',
                  }}
                  onClick={() => {
                    setPayload((prev) => ({...prev, jenisTanaman: 'sawit'}));
                    setSteps(1);
                  }}
                >
                  {newObj.SawitWord[language]}
                </button>
                <button
                  style={{
                    width: '75%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    background: '#5076ee',
                    margin: '10px auto 0px',
                  }}
                  onClick={() => {
                    setPayload((prev) => ({...prev, jenisTanaman: 'getah'}));
                    setSteps(1);
                  }}
                >
                  {newObj.GetahWord[language]}
                </button>
              </div>
            </div>
          </div>
        )}
        {steps === 1 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              gap: '20px',
              cursor: 'pointer',
            }}
          >
            <div>
              <img src={DragNDrop} alt='drag' style={{width: '200px'}} />
            </div>
            <p
              style={{
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {!isDragActive &&
                newObj.DragdropsomefileshereorclicktoselectfilesWord[language]}
              {isDragActive && !isDragReject && newObj.DropHereWord[language]}
              {isDragReject && `File type not accepted, sorry!`}
            </p>
          </div>
        )}

        {steps === 2 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
              }}
            >
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                {uploadStatus}
              </p>
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: '10px',
                  width: '100%',
                  marginTop: '10px',
                }}
              />
            </div>
          </div>
        )}

        {steps === 3 && (
          <div
            style={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
            }}
          >
            <div
              style={{
                // margin: "50px 0",
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <CheckCircleOutlineIcon
                style={{color: 'lightgreen', fontSize: '100px'}}
              />
              {newObj.FileUploadedSuccessfully[language]}
            </div>

            <Link to='/atd' style={{width: '100%'}}>
              <button
                style={{
                  color: 'black',
                  backgroundColor: 'white',
                  border: '1px solid white',
                  padding: '15px',
                  width: '100%',
                  borderRadius: '10px',
                  cursor: 'pointer',
                }}
              >
                {newObj.ATDWord[language]}
              </button>
            </Link>
            <Link to='/adminpage'>
              <div
                style={{
                  color: 'white',
                  textUnderlineOffset: '2px',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {newObj.ReturnToTheAdministratorPageWord[language]}
              </div>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
